import "../../../../../theme/style.scss";

// IMPORT PACKAGES
import * as Yup from "yup";
import { Controller, FormProvider, useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { EncryptDecryptService } from "../../../../../services/common/EncryptionService";
// IMPORT SAVEICON
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {
  Alert,
  Box,
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Typography,
  DialogActions,
  Toolbar,
  AppBar,
  Button,
  IconButton,
  styled,
  Collapse,
  FormControl,
  FormLabel,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { useContext, useEffect, useState, useRef } from "react";
import HistoryOfSimilarIllness from "../../../../OPD/OPDClinical/Components/History/Tabs/Components/HistoryOfSimilarIllness";
import AddVaccine from "../../../../OPD/OPDClinical/Components/Vaccine/_components/AddVaccine";
import LoadingButton from "@mui/lab/LoadingButton";
import { PreferencesContext } from "../../../../../PreferenceContext";
import { AlertType } from "../../../../../services/models/AlertType";
import { OPD } from "../../../../../services/models/OPD/OPD";
import { GetPatientVaccinationList } from "../../../../../services/PatientService";
import dayjs from "dayjs";
import { format, isValid } from "date-fns";
import SkeletonWrapper from "../../../../../components/Skeleton/SkeletonWrapper";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  RevertPatientVaccination,
  UpdatePatientVaccination,
} from "../../../../../services/PatientVaccinationService";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { selectOption } from "../../../../../shared/Model/Common";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomTextField } from "../../../../../components/CustomFields/TextField";
import { CustomAsyncSelect } from "../../../../../components/CustomFields/CustomSelect";
import DatePickerComponent from "../../../../../components/CustomFields/DatePicker";
import { MultiUpload } from "../../../../../components/MultiUpload/MultiUpload";
import { GetVaccineList } from "../../../../../services/VaccineService";
import { PAGE_SIZE } from "../../../../../services/common/const";
import { GetVaccineDoseList } from "../../../../../services/VaccineDoseService";
import { GetVaccineBrandList } from "../../../../../services/_VaccineBrandService";
import CloudQueueOutlinedIcon from "@mui/icons-material/CloudQueueOutlined"; // IProps
import { vaccinationGroupAgeWise } from "../../../../../shared/Data/OPD/Vaccine/vaccine";
import { UpdateMemberVaccination } from "../../../../../services/MemberVaccinationService";

interface IProps {
  opd: OPD;
  patientVaccinationColl: Array<any>;
  completedSummary: Array<any>;
  revertPatientVaccination: (vaccine: any) => Promise<void>;
  fetchPatientVaccinationList: () => Promise<void>;
  vitalParameterGridHeight?: number;
}

const skeletonRowCount = 3;

// SCHEMA FOR PARAMETER
interface Parameter {
  consumerId: string;
  orgId: string;
  branchId: string;
  departmentId: string;
  specialityId: string;
  pageIndex: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: string;
  searchValue: string;
}
// DEFAULT PARAMS -- ADD HERE IF YOU NEED NEW PARAMETER
const parameters: Parameter = {
  specialityId: "",
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  consumerId: "",
  orgId: "",
  branchId: "",
  departmentId: "",
};

interface IVaccineSchedule {
  memberVaccinationModuleId: number;
  opdId: number;
  consumerId?: number;
  specialityId: number;
  departmentId: number;
  patientId: number;
  memberVaccinationId: number;
  vaccineId: selectOption | null;
  vaccineName: string;
  familyId: number;
  familyMemberId: number;
  isCustom: boolean;
  brandId: selectOption | null;
  brandName: string;
  batchNumber: string;
  doseId: selectOption | null;
  doseName: string;
  dose: number;
  schedualOn: Date | null;
  missDoseLimit: Date | null;
  displayOrder: number;
  route: string;
  folderPath: string;
  imageFile: any[];
  imageName: string;
  serverImageName: string;
  isDeleted: boolean;
  mode: string;
  sectorName: string;
  area: string;
  city: string;
  givenBy: string;
  givenByDoctorId: number;
  givenOn: Date | null;
  reason: string;
}

interface IMembervaccination {
  vaccinationSchedulecoll: Array<IVaccineSchedule>;
}

export default function ListVaccine(props: IProps) {
  const {
    opd,
    patientVaccinationColl,
    completedSummary,
    revertPatientVaccination,
    fetchPatientVaccinationList,
  } = props;
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const navigate = useNavigate();
  const edService = new EncryptDecryptService();
  const [documentsFiles, setDocumentsFile] = useState<any>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const theme = useTheme();
  const mdd = useMediaQuery(theme.breakpoints.down("md"));
  const xld = useMediaQuery(theme.breakpoints.down("xl"));

  const [param, setParam] = useState(parameters);
  const [open, setOpen] = React.useState(false);
  // Dialog Box
  const [openDialog, setOpenDialog] = React.useState(false);
  //STORE
  const [vaccineBrandColl, setVaccineBrandColl] = useState<any[]>([]);
  const [vaccineColl, setVaccineColl] = useState<any[]>([]);
  const [vaccineDoseColl, setVaccineDoseColl] = useState<any[]>([]);
  const handleClickOpen = (value: boolean) => {
    setOpen(value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [selected, setSelected] = useState<any>();
  const [reason, setReason] = useState<string>("");

  const removeVaccineSchedule = (vaccineSchedule: IVaccineSchedule) => {
    let detailColl = vaccinationSchedulecoll || [];

    detailColl[vaccineSchedule.displayOrder].isDeleted = true;
    detailColl[vaccineSchedule.displayOrder].mode = "D";

    methods.setValue("vaccinationSchedulecoll", detailColl, {
      shouldValidate: true,
    });
  };

  const upcomingRef = useRef<HTMLDivElement | null>(null);
  const hasScrolled = useRef(false);
  let foundFirstUpcoming = false;

  const initVaccineSchedule: IVaccineSchedule = {
    memberVaccinationModuleId: 0,
    opdId: opd?.opdId || 0,
    specialityId: opd?.specialityId || 0,
    departmentId: opd?.departmentId || 0,
    patientId: opd?.patientId,
    memberVaccinationId: 0,
    vaccineId: null,
    vaccineName: "",
    familyId: 0,
    familyMemberId: 0,
    isCustom: false,
    brandId: null,
    brandName: "",
    batchNumber: "",
    doseId: null,
    doseName: "",
    dose: 0,
    schedualOn: new Date(),
    missDoseLimit: null,
    displayOrder: 0,
    route: "",
    folderPath: "",
    imageFile: [],
    imageName: "",
    serverImageName: "",
    sectorName: "",
    area: "",
    city: "",
    givenBy: "",
    givenByDoctorId: 0,
    givenOn: null,
    isDeleted: false,
    reason: "",
    mode: "I",
  };

  const initPatientVaccination: IMembervaccination = {
    vaccinationSchedulecoll: [initVaccineSchedule],
  };

  //SCHEMA VALIDATION
  const validationSchema = Yup.object().shape({
    vaccinationSchedulecoll: Yup.array().of(
      Yup.object().shape({
        memberVaccinationModuleId: Yup.number().required(),
        opdId: Yup.number().required(),
        specialityId: Yup.number().required(),
        departmentId: Yup.number().required(),
        patientId: Yup.number().required(),
        memberVaccinationId: Yup.number().required(),
        vaccineId: Yup.object()
          .shape({
            value: Yup.string(),
            label: Yup.string(),
          })
          .required("Generic name is required"),
        vaccineName: Yup.string().required(),
        familyId: Yup.number().required(),
        familyMemberId: Yup.number().required(),
        isCustom: Yup.boolean().required(),
        brandId: Yup.object()
          .shape({
            value: Yup.string(),
            label: Yup.string(),
          })
          .nullable(),
        // .required("Brand is required"),
        brandName: Yup.string().nullable(),
        batchNumber: Yup.string().nullable(),
        doseId: Yup.object()
          .shape({
            value: Yup.string(),
            label: Yup.string(),
          })
          .nullable("Dose is required"),
        doseName: Yup.string().required(),
        dose: Yup.number().required(),
        schedualOn: Yup.date().required(),
        missDoseLimit: Yup.date().nullable(),
        displayOrder: Yup.number().required(),
        route: Yup.string().nullable(),
        folderPath: Yup.string(),
        imageName: Yup.string(),
        serverImageName: Yup.string(),
        sectorName: Yup.string().nullable(),
        area: Yup.string().nullable(),
        city: Yup.string().nullable(),
        givenBy: Yup.string().when("reason", {
          is: (reason) => reason === "GIVEN",
          then: (schema) => schema.nullable(),
          otherwise: (schema) => schema.nullable(),
        }),
        givenByDoctorId: Yup.number().when("reason", {
          is: (reason) => reason === "GIVEN",
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.nullable(),
        }),
        givenOn: Yup.date().when("reason", {
          is: (reason) => reason === "GIVEN",
          then: (schema) => schema.required("givenOn is required"),
          otherwise: (schema) => schema.nullable(),
        }),
        isDeleted: Yup.boolean().required(),
        mode: Yup.string(),
        reason: Yup.string(),
      }),
    ),
  });

  // FORM HOOK
  const methods = useForm({
    resolver: yupResolver(validationSchema), // IGNORE THIS ERROR
    defaultValues: initPatientVaccination, // DEFAULT VALUE -- DON'T CREATE STATE FOR IT -- STATE CAN INCREASE SITE LOAD
  });

  const vaccinationSchedulecoll = useWatch({
    name: "vaccinationSchedulecoll",
    control: methods.control,
  });

  const saveLogoFileSelected = (files: any) => {
    setDocumentsFile(files);
  };

  const dowloadDocumentFile = (files: { name: any }) => {
    const selectedFile = documentsFiles.find(
      (doc: { name: any }) => files?.name === doc?.name,
    );

    if (selectedFile && selectedFile.preview) {
      const downloadLink = document.createElement("a");
      downloadLink.href = selectedFile.preview; // Changed from `documentFile` to `preview` based on your data structure
      downloadLink.download = selectedFile.name; // Changed from `fileOriginalName` to `name` based on your data structure
      downloadLink.click();
    }
  };

  const removeFile = (file: { name: any }) => {
    const updatedFiles = documentsFiles.filter(
      (doc: { name: any }) => doc.name !== file?.name,
    );
    setDocumentsFile(updatedFiles);
  };

  // GET LIST OF VACCINE
  const fetchVaccine = async (searchValue: string, oninit: boolean) => {
    try {
      let vaccineColl = [];
      let params = new URLSearchParams();
      params.append("pageIndex", param.pageIndex?.toString());
      params.append("pageSize", param.pageSize?.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchValue);
      const result: any = await GetVaccineList(params);
      if (result?.data?.data?.vaccineColl) {
        vaccineColl = result?.data?.data?.vaccineColl;
        if (oninit) setVaccineColl(vaccineColl);
      }
      return vaccineColl;
    } catch (e) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // FILTER  VACCINE
  async function filterVaccine(inputValue: string) {
    let result = await fetchVaccine(inputValue, false);
    return result;
  }

  //  VACCINE LOAD ON SEARCH
  const loadVaccineList = (
    inputValue: string,
    callback: (options: any) => void,
  ) => {
    if (inputValue && inputValue.length > 0) {
      filterVaccine(inputValue?.trim()).then((r) => {
        callback(r);
      });
    } else {
      callback([]);
    }
  };

  // GET LIST OF VACCCINE BRAND
  const fetchVaccineBrand = async (
    vaccineId: string,
    searchValue: string,
    oninit: boolean,
  ) => {
    try {
      let vaccineBrandColl = [];
      let params = new URLSearchParams();
      params.append("vaccineId", vaccineId);
      params.append("pageIndex", param.pageIndex?.toString());
      params.append("pageSize", param.pageSize?.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchValue);
      const result: any = await GetVaccineBrandList(params);
      if (result?.data?.data?.vaccineBrandColl) {
        vaccineBrandColl = result?.data?.data?.vaccineBrandColl;
        if (oninit) setVaccineBrandColl(vaccineBrandColl);
      }
      return vaccineBrandColl;
    } catch (e) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // FILTER  VACCCINE BRAND
  async function filterVaccineBrand(vaccineId: string, inputValue: string) {
    let result = await fetchVaccineBrand(
      selected?.vaccineId,
      inputValue,
      false,
    );
    return result;
  }

  //  VACCCINE BRAND LOAD ON SEARCH
  const loadVaccineBrandList = (
    vaccineId: string,
    inputValue: string,
    callback: (options: any) => void,
  ) => {
    if (inputValue && inputValue.length > 0) {
      filterVaccineBrand(vaccineId, inputValue).then((r) => {
        callback(r);
      });
    } else {
      callback([]);
    }
  };

  // GET LIST OF VACCCINE DOSE
  const fetchVaccineDose = async (
    vaccineId: string,
    searchValue: string,
    oninit: boolean,
  ) => {
    try {
      let vaccineDoseColl = [];
      let params = new URLSearchParams();
      params.append("vaccineId", vaccineId);
      params.append("pageIndex", param.pageIndex?.toString());
      params.append("pageSize", param.pageSize?.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchValue);
      const result: any = await GetVaccineDoseList(params);
      if (result?.data?.data?.vaccineDoseColl) {
        vaccineDoseColl = result?.data?.data?.vaccineDoseColl;
        if (oninit) setVaccineDoseColl(vaccineDoseColl);
      }
      return vaccineDoseColl;
    } catch (e) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // FILTER  VACCCINE DOSE
  async function filterVaccineDose(vaccineId: string, inputValue: string) {
    let result = await fetchVaccineDose(selected?.vaccineId, inputValue, false);
    return result;
  }

  //  VACCCINE DOSE LOAD ON SEARCH
  const loadVaccineDoseList = (
    vaccineId: string,
    inputValue: string,
    callback: (options: any) => void,
  ) => {
    if (inputValue && inputValue.length > 0) {
      filterVaccineDose(vaccineId, inputValue).then((r) => {
        callback(r);
      });
    } else {
      callback([]);
    }
  };

  const savePatientVaccination = async (value: IMembervaccination) => {
    try {
      let result: any = "";
      const vaccinationSchedulecoll = value?.vaccinationSchedulecoll?.map(
        (x) => {
          let col: any = x;
          col.consumerId = userContext.consumerId || 0;
          col.opdId = opd?.opdId || 0;
          col.branchId = userContext.branchId || 0;
          col.orgId = userContext.organizationId || 0;
          col.specialityId = opd?.specialityId || 0;
          col.departmentId = opd?.departmentId || 0;
          col.brandId = x.brandId?.value || 0;
          col.vaccineId = x.vaccineId?.value || 0;
          col.doseId = x.doseId?.value || 0;
          col.mode = x.mode || "I";
          col.imageFile = documentsFiles[0] || [];
          col.schedualOn =
            x?.schedualOn !== null && x?.schedualOn !== undefined
              ? dayjs(x?.schedualOn).format("YYYY-MM-DD")
              : null;
          col.givenOn =
            x?.givenOn !== null && x?.givenOn !== undefined
              ? dayjs(x?.givenOn).format("YYYY-MM-DD")
              : null;
          col.missDoseLimit =
            x?.missDoseLimit !== null && x?.missDoseLimit !== undefined
              ? dayjs(x?.missDoseLimit).format("YYYY-MM-DD")
              : null;
          return col;
        },
      );
      let formData = {
        vaccinationScheduleCollJson: JSON.stringify(vaccinationSchedulecoll),
        dataManagedBy: userContext.loginDetail.userId,
      };
      result = await UpdateMemberVaccination(formData);
      if (result?.data) {
        setSelected("");
        fetchPatientVaccinationList();

        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: result?.message,
          alertType: AlertType.Success,
        });
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "Something went wrong.",
          alertType: AlertType.Error,
        });
      }
    } catch (e) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  };

  // ON SUBMIT OF FORM
  const onSubmit = async (data: any) => {
    setIsLoading(true);
    await savePatientVaccination(data);
    setIsLoading(false);
  };

  // HANDLE ADD VACCINE
  const handleAddVaccination = async (item: any, code: string) => {
    setSelected(item);
    setReason(code);
    try {
      if (item?.vaccineId > 0) {
        await fetchVaccineBrand(item?.vaccineId || 0, "", true);
        await fetchVaccineDose(item?.vaccineId || 0, "", true);
      }
      const vaccineColl = methods.getValues("vaccinationSchedulecoll");
      let updatedVaccColl = vaccineColl?.map((vac, index) => {
        vac.memberVaccinationModuleId = item?.memberVaccinationModuleId || 0;
        vac.opdId = code === "GIVEN" ? opd?.opdId || 0 : 0;
        vac.specialityId = code === "GIVEN" ? opd?.specialityId || 0 : 0;
        vac.departmentId = code === "GIVEN" ? opd?.departmentId || 0 : 0;
        vac.patientId = opd?.patientId;
        vac.memberVaccinationId = item?.memberVaccinationId || 0;
        vac.vaccineId =
          item?.vaccineId > 0
            ? { label: item?.name || "", value: item?.vaccineId?.toString() }
            : null;
        vac.vaccineName = item?.name || "";
        vac.familyId = 0;
        vac.familyMemberId = 0;
        vac.isCustom = code === "CUSTOM" ? true : false;
        vac.brandId =
          item?.brandId > 0
            ? {
                label: item?.brandName || "",
                value: item?.brandId?.toString(),
              }
            : null;
        vac.brandName = item?.brandName || "";
        vac.batchNumber = item?.batchNumber || "";
        vac.doseId =
          item?.doseId > 0
            ? {
                label: item?.doseName || "",
                value: item?.doseId?.toString(),
              }
            : null;
        vac.doseName = item?.doseName || "";
        vac.dose = item?.dose || 0;
        vac.schedualOn =
          item?.schedualOn !== null &&
          item?.schedualOn !== "" &&
          item?.schedualOn !== undefined
            ? new Date(item?.schedualOn)
            : new Date();
        vac.missDoseLimit =
          item?.missDoseLimit !== null &&
          item?.missDoseLimit !== "" &&
          item?.missDoseLimit !== undefined
            ? new Date(item?.missDoseLimit)
            : null;
        vac.displayOrder = index;
        vac.route = item?.route || "";
        vac.folderPath = "";
        vac.imageFile = documentsFiles[0] || null;
        vac.imageName = "";
        vac.serverImageName = "";
        vac.sectorName = item?.sectorName || "";
        vac.area = item?.area || "";
        vac.city = item?.city || "";
        vac.givenBy = code === "GIVEN" ? opd?.consultingDoctorName || "" : "";
        vac.givenByDoctorId =
          code === "GIVEN" ? opd?.consultingDoctorId || 0 : 0;
        vac.givenOn =
          code === "GIVEN"
            ? item?.givenOn !== null &&
              item?.givenOn !== "" &&
              item?.givenOn !== undefined
              ? new Date(item?.givenOn)
              : new Date()
            : null;
        vac.isDeleted = false;
        vac.reason = code;
        vac.mode = item?.memberVaccinationModuleId > 0 ? "U" : "I";
        return vac;
      });
      methods.reset(
        { vaccinationSchedulecoll: updatedVaccColl },
        { keepDirty: true, keepIsValid: true },
      );
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  // HANDLE ADD NEW ROW
  // const addRowAddVaccine = () => {
  //   const maxRowNumber = vaccinationSchedulecoll?.reduce(
  //     (acc, curr) => (acc = curr.displayOrder > acc ? curr.displayOrder : acc),
  //     0
  //   );

  //   const newRow: IVaccineSchedule = {
  //     displayOrder: maxRowNumber + 1,
  //     memberVaccinationModuleId: 0,
  //     opdId: opd.opdId,
  //     specialityId: opd.specialityId,
  //     departmentId: opd.departmentId,
  //     patientId: opd.patientId,
  //     memberVaccinationId: 0,
  //     vaccineId: null,
  //     vaccineName: "",
  //     familyId: 0,
  //     familyMemberId: 0,
  //     isCustom: false,
  //     brandId: null,
  //     brandName: "",
  //     batchNumber: "",
  //     doseId: null,
  //     doseName: "",
  //     dose: 0,
  //     schedualOn: new Date(),
  //     missDoseLimit: null,
  //     route: "",
  //     folderPath: "",
  //     imageFile: [],
  //     imageName: "",
  //     serverImageName: "",
  //     sectorName: "",
  //     area: "",
  //     city: "",
  //     givenBy: "",
  //     givenByDoctorId: 0,
  //     givenOn: new Date(),
  //     isDeleted: false,
  //     mode: "I",
  //     reason: ""
  //   };

  //   methods.setValue(
  //     "vaccinationSchedulecoll",
  //     [...vaccinationSchedulecoll, newRow],
  //     {
  //       shouldValidate: true,
  //     }
  //   );
  // };

  // FETCH DATA

  const fetchData = async () => {
    try {
      // if (opd?.opdId > 0) {
      await fetchVaccine("", true);
      // }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  };

  // USEEFFECTS
  useEffect(() => {
    setIsLoading(true);
    fetchData();
  }, []);

  useEffect(() => {
    if (upcomingRef.current && !hasScrolled.current) {
      upcomingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      hasScrolled.current = true;
    }
  }, [patientVaccinationColl]);

  return (
    <Box className="main-container" pl={0}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} action="">
          <Grid container spacing={2} sx={{ padding: "10px 20px 10px 20px" }}>
            <Grid item xs={12} md={opd?.isEditable ? 6 : 12}>
              <Box
                sx={{
                  border: "1px solid #0000001f",
                  borderRadius: "10px",
                  overflow: "hidden",
                  backgroundColor: "var(--opd-panel-bg)",
                }}
              >
                <Box
                  className="inner-header-container"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: "var(--opd-header-bg)",
                    //flexDirection: "column",
                    padding: "10px",
                    gap: "2px",
                    height: "60px",
                  }}
                >
                  <Typography>
                    <Typography style={{ fontWeight: 600, fontSize: "1opx" }}>
                      Vaccination
                    </Typography>
                    <Typography
                      style={{ color: "#414d56" }}
                      className={"font-size-12"}
                    >
                      Date of Birth:{" "}
                      {opd?.patientBirthDate
                        ? format(opd?.patientBirthDate, "dd-MM-yyyy")
                        : " - "}
                    </Typography>
                  </Typography>
                  {/* <Typography>
                    {opd.isEditable && (
                      <Button
                        sx={{ marginRight: "15px", lineHeight: 2 }}
                        color="primary"
                        startIcon={<AddIcon />}
                        variant="contained"
                        className="primary-button"
                        name="add"
                        onClick={(e) => {
                          handleAddVaccination(
                            { name: "Custom Vaccine" },
                            "CUSTOM"
                          );
                          if (mdd) {
                            handleClickOpen(true);
                          }
                        }}
                        disabled={isLoading}
                      >
                        Add
                      </Button>
                    )}
                  </Typography> */}
                </Box>
                <Divider />
                <Grid container>
                  {isLoading ? (
                    <>
                      <Grid container spacing={0}>
                        {Array(skeletonRowCount)
                          ?.fill(0)
                          ?.map((skeletonRow, index) => {
                            return (
                              <Grid
                                item
                                xs={12}
                                key={"skeleton-row" + index?.toString()}
                                sx={{
                                  borderBottom: "1px solid #ced4da",
                                }}
                              >
                                <SkeletonWrapper
                                  isLoading={isLoading}
                                  variant="rectangular"
                                  className="skeleton-draggable-item"
                                >
                                  <span></span>
                                </SkeletonWrapper>
                              </Grid>
                            );
                          })}
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={12}>
                      <Grid item container spacing={1} className="py-8">
                        {Object.entries(
                          patientVaccinationColl?.reduce(
                            (acc: any, vac: any) => {
                              const groupId = vac?.vaccineGroupId;
                              const groupName =
                                vac?.vaccineGroupName || "Other";
                              const key = `${groupId}_${groupName}`;
                              if (!acc[key]) {
                                acc[key] = { groupName, groupId, vaccines: [] };
                              }
                              acc[key].vaccines.push(vac);
                              return acc;
                            },
                            {},
                          ),
                        )?.map(([key, groupData]: [string, any], index) => {
                          let hasAttachRef = false;
                          const vaccineColl = groupData?.vaccines || [];
                          const groupName = groupData?.groupName;

                          // Check if any vaccine in this group will have the attachRef
                          const checkAttach = vaccineColl?.some(
                            (item: any) =>
                              item?.status?.toUpperCase() === "CURRENT DUE" &&
                              !foundFirstUpcoming,
                          );
                          if (checkAttach) hasAttachRef = true;

                          return (
                            <Grid
                              item
                              xs={12}
                              sx={{
                                display:
                                  vaccineColl?.length > 0 ? "block" : "none",
                              }}
                            >
                              <Box className="px-8">
                                <Box
                                  sx={{
                                    border: hasAttachRef
                                      ? "1px solid #f5a623"
                                      : "1px solid #414d55",
                                    borderRadius: "4px",
                                    outline: hasAttachRef
                                      ? "2px solid #f5a623"
                                      : "none",
                                    overflow: "hidden",
                                  }}
                                  key={index?.toString()}
                                >
                                  <Box
                                    className="p-8"
                                    sx={{
                                      backgroundColor: hasAttachRef
                                        ? "#f5a623"
                                        : "#414d55",
                                      color: "white",
                                    }}
                                  >
                                    <Typography className="bold-600">
                                      {groupName}
                                    </Typography>
                                  </Box>
                                  <Grid container>
                                    {vaccineColl &&
                                      vaccineColl?.map((item) => {
                                        const isUpcoming =
                                          item?.status?.toUpperCase() ===
                                          "CURRENT DUE";
                                        const attachRef =
                                          isUpcoming && !foundFirstUpcoming;

                                        if (attachRef)
                                          foundFirstUpcoming = true;
                                        return (
                                          <Grid
                                            item
                                            xs={12}
                                            key={item?.memberVaccinationModuleId?.toString()}
                                            ref={attachRef ? upcomingRef : null}
                                          >
                                            <Box
                                              className="vaccine-grid"
                                              sx={{
                                                backgroundColor:
                                                  item?.status?.toUpperCase() ===
                                                  "COMPLETED"
                                                    ? "#edf7ed"
                                                    : item?.status?.toUpperCase() ===
                                                        "UPCOMING"
                                                      ? "white"
                                                      : item?.status?.toUpperCase() ===
                                                          "OVERDUE"
                                                        ? "#fdeded"
                                                        : item?.status?.toUpperCase() ===
                                                            "NEXT DUE"
                                                          ? "#fff4e5"
                                                          : item?.status?.toUpperCase() ===
                                                              "CURRENT DUE"
                                                            ? "#fff4e5"
                                                            : "#ffffff",
                                              }}
                                            >
                                              <Grid container spacing={1}>
                                                <Grid item xs={12} xl={8}>
                                                  {opd?.isEditable ? (
                                                    <Typography
                                                      sx={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                      }}
                                                      className={` font-size-14 ${
                                                        item?.opdId ===
                                                          opd?.opdId ||
                                                        item?.opdId === 0
                                                          ? " blue-link link-cursor"
                                                          : ""
                                                      }`}
                                                      onClick={() => {
                                                        if (
                                                          item?.opdId ===
                                                            opd?.opdId ||
                                                          item?.opdId === 0
                                                        ) {
                                                          handleAddVaccination(
                                                            item,
                                                            "GIVEN",
                                                          );
                                                          if (mdd) {
                                                            handleClickOpen(
                                                              true,
                                                            );
                                                          }
                                                        }
                                                      }}
                                                    >
                                                      {item?.brandName}{" "}
                                                      {item?.name
                                                        ? " (" +
                                                          item?.name +
                                                          ") "
                                                        : ""}
                                                      {item?.doseName}
                                                    </Typography>
                                                  ) : (
                                                    <Typography
                                                      sx={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                      }}
                                                      className={` font-size-14 `}
                                                    >
                                                      {item?.brandName}{" "}
                                                      {item?.name
                                                        ? " (" +
                                                          item?.name +
                                                          ") "
                                                        : ""}
                                                      {item?.doseName}
                                                    </Typography>
                                                  )}
                                                  {item?.batchNumber && (
                                                    <Typography className="">
                                                      {"Batch No: "}
                                                      {item.batchNumber}
                                                    </Typography>
                                                  )}
                                                  {(item?.caseNumber ||
                                                    item?.givenOn ||
                                                    item?.schedualOn) && (
                                                    <Typography className="grey-400 ">
                                                      {item?.caseNumber
                                                        ? `${item.caseNumber} | `
                                                        : ""}
                                                      {item?.givenOn
                                                        ? `Vaccination Date: ${format(
                                                            item.givenOn,
                                                            "dd-MM-yyyy",
                                                          )} | `
                                                        : ""}
                                                      {item?.schedualOn
                                                        ? `Schedule Date: ${format(
                                                            item.schedualOn,
                                                            "dd-MM-yyyy",
                                                          )}`
                                                        : ""}
                                                    </Typography>
                                                  )}
                                                </Grid>
                                                <Grid item xs={12} xl={4}>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      gap: 2,
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    {item?.status?.toUpperCase?.() !==
                                                      "COMPLETED" &&
                                                    opd?.isEditable ? (
                                                      <Typography
                                                        sx={{
                                                          cursor: "pointer",
                                                          minWidth:
                                                            "max-content",
                                                          display: "flex",
                                                          flexWrap: "wrap",
                                                          width: "100%",
                                                        }}
                                                        className={
                                                          "blue-link font-size-14"
                                                        }
                                                        onClick={() => {
                                                          handleAddVaccination(
                                                            item,
                                                            "NEXT_SCHEDULE",
                                                          );
                                                          if (mdd) {
                                                            handleClickOpen(
                                                              true,
                                                            );
                                                          }
                                                        }}
                                                      >
                                                        Next Schedule
                                                      </Typography>
                                                    ) : (
                                                      <Typography
                                                        sx={{
                                                          minWidth:
                                                            "max-content",
                                                          display: "flex",
                                                          flexWrap: "wrap",
                                                          width: "100%",
                                                        }}
                                                        className={
                                                          "font-size-14"
                                                        }
                                                      >
                                                        Next Schedule
                                                      </Typography>
                                                    )}
                                                    {item?.status?.toUpperCase() ===
                                                      "COMPLETED" &&
                                                      item?.opdId ===
                                                        opd?.opdId &&
                                                      xld && (
                                                        <Typography
                                                          sx={{
                                                            cursor: "pointer",
                                                            minWidth:
                                                              "max-content",
                                                            display: "flex",
                                                            flexWrap: "wrap",
                                                            width: "100%",
                                                          }}
                                                          onClick={async () => {
                                                            setIsLoading(true);
                                                            await revertPatientVaccination(
                                                              item,
                                                            );
                                                            await fetchPatientVaccinationList();
                                                            setIsLoading(false);
                                                          }}
                                                          className="remove-note"
                                                        >
                                                          Remove
                                                        </Typography>
                                                      )}
                                                    <Box
                                                      sx={{
                                                        width: "100%",
                                                      }}
                                                    >
                                                      <Box className="action-icon-placement">
                                                        <Alert
                                                          icon={false}
                                                          className={
                                                            "badge-new1 " +
                                                            (item?.status?.toUpperCase() ===
                                                            "UPCOMING"
                                                              ? " badge-gray"
                                                              : item?.status?.toUpperCase() ===
                                                                  "COMPLETED"
                                                                ? " badge-success"
                                                                : item?.status?.toUpperCase() ===
                                                                    "NEXT DUE"
                                                                  ? " badge-warning"
                                                                  : item?.status?.toUpperCase() ===
                                                                      "CURRENT DUE"
                                                                    ? " badge-warning"
                                                                    : " badge-danger")
                                                          }
                                                          sx={{
                                                            minWidth:
                                                              "max-content",
                                                          }}
                                                        >
                                                          {item?.status}
                                                        </Alert>
                                                      </Box>
                                                      {item?.status?.toUpperCase() ===
                                                        "COMPLETED" &&
                                                        item?.opdId ===
                                                          opd?.opdId &&
                                                        !xld && (
                                                          <Typography
                                                            sx={{
                                                              cursor: "pointer",
                                                              minWidth:
                                                                "max-content",
                                                              display: "flex",
                                                              justifyContent:
                                                                "flex-end",
                                                              flexWrap: "wrap",
                                                              width: "100%",
                                                            }}
                                                            onClick={async () => {
                                                              setIsLoading(
                                                                true,
                                                              );
                                                              await revertPatientVaccination(
                                                                item,
                                                              );
                                                              await fetchPatientVaccinationList();
                                                              setIsLoading(
                                                                false,
                                                              );
                                                            }}
                                                            className="remove-note"
                                                          >
                                                            Remove
                                                          </Typography>
                                                        )}
                                                    </Box>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </Box>
                                          </Grid>
                                        );
                                      })}
                                  </Grid>
                                </Box>
                              </Box>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>
            {!mdd && opd?.isEditable && (
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    border: "1px solid #0000001f",
                    borderRadius: "10px",
                    overflow: "hidden",
                    backgroundColor: "var(--opd-panel-bg)",
                  }}
                  style={{
                    position: "sticky",
                    top: props?.vitalParameterGridHeight
                      ? props?.vitalParameterGridHeight + "px"
                      : "5px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "var(--opd-header-bg)",
                      height: "60px",
                    }}
                    className="inner-header-container"
                  >
                    <Typography
                      className={selected?.name ? "symptom-text" : ""}
                      style={{ fontWeight: 600 }}
                    >
                      {selected?.name
                        ? selected?.name +
                          (selected?.doseName ? " - " + selected?.doseName : "")
                        : "Vaccination Summary"}
                    </Typography>
                    {selected?.name ? (
                      <>
                        <Typography>
                          <LoadingButton
                            sx={{ marginRight: "15px" }}
                            color="primary"
                            loadingPosition="start"
                            startIcon={<></>}
                            variant="contained"
                            type="submit"
                            className="primary-button"
                            name="save"
                            onClick={(e) => {
                              console.log(methods.formState.errors);
                            }}
                            disabled={isLoading}
                          >
                            Save
                          </LoadingButton>
                          <IconButton
                            onClick={() => setSelected(null)} // Change "" to null for better logic
                            sx={{ padding: 0, margin: 0 }}
                            aria-label="delete"
                          >
                            <CloseRoundedIcon sx={{ color: " #d32f2f" }} />
                          </IconButton>
                        </Typography>
                      </>
                    ) : null}
                  </Box>
                  <Divider />
                  {selected?.name && (
                    <Box
                      sx={{
                        padding: "10px",
                      }}
                    >
                      <Grid container spacing={2}>
                        {vaccinationSchedulecoll
                          ?.filter(
                            (x) => x.isDeleted === false && x.mode !== "D",
                          )
                          ?.map((vaccineSchedule, index, arr) => {
                            let arrLength = arr?.length;
                            return (
                              <Grid
                                key={vaccineSchedule?.displayOrder?.toString()}
                                item
                                xs={12}
                              >
                                <Box className="group-container">
                                  <Grid container spacing={2}>
                                    {reason === "GIVEN" && (
                                      <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth>
                                          <FormLabel
                                            className={`fileds-label-text  ${
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll &&
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll[
                                                vaccineSchedule.displayOrder
                                              ]?.givenOn
                                                ? "validation-message"
                                                : ""
                                            }`}
                                          >
                                            Vaccination Date *
                                          </FormLabel>
                                          <SkeletonWrapper
                                            isLoading={isLoading}
                                            className="skeleton-input"
                                          >
                                            <DatePickerComponent
                                              format="DD-MM-YYYY"
                                              disabled={false}
                                              mode="date"
                                              maxDate={dayjs()}
                                              slotProps={{
                                                textField: { size: "small" },
                                              }}
                                              value={
                                                vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.givenOn
                                                  ? dayjs(
                                                      vaccinationSchedulecoll[
                                                        vaccineSchedule
                                                          .displayOrder
                                                      ]?.givenOn,
                                                    )
                                                  : null
                                              }
                                              onChange={(e: any) => {
                                                if (
                                                  e !== null &&
                                                  isValid(e.$d)
                                                ) {
                                                  let savedDateFormate: any =
                                                    format(e.$d, "yyyy-MM-dd");
                                                  methods.setValue(
                                                    `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.givenOn`,
                                                    savedDateFormate,
                                                  );
                                                }
                                              }}
                                            />
                                          </SkeletonWrapper>
                                        </FormControl>
                                      </Grid>
                                    )}
                                    {["NEXT_SCHEDULE", "CUSTOM"].includes(
                                      reason,
                                    ) && (
                                      <Grid item xs={12} sm={6} md={6}>
                                        <FormControl fullWidth>
                                          <FormLabel
                                            className={`fileds-label-text  ${
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll &&
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll[
                                                vaccineSchedule.displayOrder
                                              ]?.schedualOn
                                                ? "validation-message"
                                                : ""
                                            }`}
                                          >
                                            Schedule Date *
                                          </FormLabel>
                                          <SkeletonWrapper
                                            isLoading={isLoading}
                                            className="skeleton-input"
                                          >
                                            <DatePickerComponent
                                              format="DD-MM-YYYY"
                                              disabled={false}
                                              mode="date"
                                              // minDate={dayjs()}
                                              // disablePast
                                              slotProps={{
                                                textField: { size: "small" },
                                              }}
                                              value={
                                                vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.schedualOn
                                                  ? dayjs(
                                                      vaccinationSchedulecoll[
                                                        vaccineSchedule
                                                          .displayOrder
                                                      ]?.schedualOn,
                                                    )
                                                  : null
                                              }
                                              onChange={(e: any) => {
                                                if (
                                                  e !== null &&
                                                  isValid(e.$d)
                                                ) {
                                                  let savedDateFormate: any =
                                                    format(e.$d, "yyyy-MM-dd");
                                                  methods.setValue(
                                                    `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.schedualOn`,
                                                    savedDateFormate,
                                                  );
                                                }
                                              }}
                                            />
                                          </SkeletonWrapper>
                                        </FormControl>
                                      </Grid>
                                    )}
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "start",
                                      }}
                                    >
                                      {arrLength > 1 && (
                                        <Button
                                          variant="text"
                                          onClick={() => {
                                            removeVaccineSchedule(
                                              vaccineSchedule,
                                            );
                                          }}
                                        >
                                          <RemoveIcon className="remove-note" />
                                          <span className="remove-note">
                                            Remove Vaccine
                                          </span>
                                        </Button>
                                      )}
                                    </Grid>
                                  </Grid>
                                  <Grid container>
                                    <Box
                                      sx={{
                                        border: "1px solid lightgray",
                                        borderRadius: 2,
                                        marginTop: "10px",
                                        padding: "10px",
                                        width: "100%",
                                      }}
                                    >
                                      <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                          <FormControl fullWidth>
                                            <FormLabel
                                              className={`fileds-label-text  ${
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll &&
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.vaccineId
                                                  ? "validation-message"
                                                  : ""
                                              }`}
                                            >
                                              Generic Name *
                                            </FormLabel>
                                            <SkeletonWrapper
                                              isLoading={isLoading}
                                              className="skeleton-input"
                                            >
                                              <Controller
                                                control={methods.control}
                                                name={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`}
                                                render={({ field }) => (
                                                  <CustomAsyncSelect
                                                    {...field}
                                                    id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`}
                                                    FieldName={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`}
                                                    defaultOptions={vaccineColl}
                                                    isDisabled={true}
                                                    loadOptions={
                                                      loadVaccineList
                                                    }
                                                    openMenuOnFocus
                                                    isClearable
                                                    isSearchable
                                                    menuPortalTarget={document.querySelector(
                                                      "body",
                                                    )}
                                                    isNotCreatable
                                                    handleChange={async (e) => {
                                                      if (
                                                        methods
                                                          ?.getValues()
                                                          ?.vaccinationSchedulecoll[
                                                            vaccineSchedule
                                                              .displayOrder
                                                          ]?.vaccineId?.value?.toString() !==
                                                        e?.value?.toString()
                                                      ) {
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`,
                                                          e?.value ? e : null,
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineName`,
                                                          e?.value
                                                            ? e?.label
                                                            : "",
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`,
                                                          null,
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandName`,
                                                          "",
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseId`,
                                                          null,
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );

                                                        if (e?.value) {
                                                          setIsLoading(true);
                                                          await fetchVaccineBrand(
                                                            e.value,
                                                            "",
                                                            true,
                                                          );
                                                          await fetchVaccineDose(
                                                            e.value,
                                                            "",
                                                            true,
                                                          );
                                                          setIsLoading(false);
                                                        } else {
                                                          setVaccineBrandColl(
                                                            [],
                                                          );
                                                          setVaccineDoseColl(
                                                            [],
                                                          );
                                                        }
                                                      }
                                                    }}
                                                  />
                                                )}
                                              />
                                            </SkeletonWrapper>
                                          </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                          <FormControl fullWidth>
                                            <FormLabel
                                              className={`fileds-label-text  ${
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll &&
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.brandId
                                                  ? "validation-message"
                                                  : ""
                                              }`}
                                            >
                                              Brand
                                            </FormLabel>
                                            <SkeletonWrapper
                                              isLoading={isLoading}
                                              className="skeleton-input"
                                            >
                                              <Controller
                                                control={methods.control}
                                                name={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`}
                                                render={({ field }) => (
                                                  <CustomAsyncSelect
                                                    {...field}
                                                    isCreatable
                                                    id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`}
                                                    FieldName={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`}
                                                    defaultOptions={
                                                      vaccineBrandColl
                                                    }
                                                    loadOptions={(
                                                      input,
                                                      callBack,
                                                    ) => {
                                                      loadVaccineBrandList(
                                                        methods.getValues()
                                                          ?.vaccinationSchedulecoll[
                                                          vaccineSchedule
                                                            ?.displayOrder
                                                        ]?.vaccineId?.value ??
                                                          "",
                                                        input?.trim(),
                                                        callBack,
                                                      );
                                                    }}
                                                    isDisabled={
                                                      parseInt(
                                                        methods?.getValues()
                                                          ?.vaccinationSchedulecoll[
                                                          vaccineSchedule
                                                            .displayOrder
                                                        ]?.vaccineId?.value ??
                                                          "0",
                                                      ) <= 0
                                                    }
                                                    openMenuOnFocus
                                                    isClearable
                                                    isSearchable
                                                    menuPortalTarget={document.querySelector(
                                                      "body",
                                                    )}
                                                    handleChange={(e: any) => {
                                                      if (e?.__isNew__) {
                                                        const vaccineId =
                                                          methods.getValues()
                                                            ?.vaccinationSchedulecoll[
                                                            vaccineSchedule
                                                              ?.displayOrder
                                                          ]?.vaccineId?.value;
                                                        if (vaccineId) {
                                                          const encryptedVaccineId: any =
                                                            edService.encrypt(
                                                              vaccineId,
                                                            );
                                                          navigate(
                                                            `/master/vaccine/vaccine-save?q=${encodeURIComponent(encryptedVaccineId)}`,
                                                          );
                                                        }
                                                      } else {
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`,
                                                          e?.value ? e : null,
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                        methods.setValue(
                                                          `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandName`,
                                                          e?.value
                                                            ? e?.label
                                                            : "",
                                                          {
                                                            shouldValidate: true,
                                                          },
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                              />
                                            </SkeletonWrapper>
                                          </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                          {/* <FormControl fullWidth>
                                            <FormLabel
                                              className={`fileds-label-text  ${
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll &&
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.doseId
                                                  ? "validation-message"
                                                  : ""
                                              }`}
                                            >
                                              Dose *
                                            </FormLabel>
                                            <SkeletonWrapper
                                              isLoading={isLoading}
                                              className="skeleton-input"
                                            >
                                              <Controller
                                                control={methods.control}
                                                name={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseId`}
                                                render={({ field }) => (
                                                  <CustomAsyncSelect
                                                    {...field}
                                                    id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseId`}
                                                    FieldName={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseId`}
                                                    defaultOptions={
                                                      vaccineDoseColl
                                                    }
                                                    isNotCreatable
                                                    loadOptions={(
                                                      input,
                                                      callBack
                                                    ) => {
                                                      loadVaccineDoseList(
                                                        methods.getValues()
                                                          ?.vaccinationSchedulecoll[
                                                          vaccineSchedule
                                                            ?.displayOrder
                                                        ]?.vaccineId?.value ??
                                                          "",
                                                        input?.trim(),
                                                        callBack
                                                      );
                                                    }}
                                                    isDisabled={
                                                      parseInt(
                                                        methods?.getValues()
                                                          ?.vaccinationSchedulecoll[
                                                          vaccineSchedule
                                                            .displayOrder
                                                        ]?.vaccineId?.value ??
                                                          "0"
                                                      ) <= 0
                                                    }
                                                    openMenuOnFocus
                                                    isClearable
                                                    isSearchable
                                                    menuPortalTarget={document.querySelector(
                                                      "body"
                                                    )}
                                                    handleChange={(e) => {
                                                      methods.setValue(
                                                        `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseId`,
                                                        e?.value ? e : null,
                                                        {
                                                          shouldValidate: true,
                                                        }
                                                      );
                                                      methods.setValue(
                                                        `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseName`,
                                                        e?.value
                                                          ? e?.label
                                                          : null,
                                                        {
                                                          shouldValidate: true,
                                                        }
                                                      );
                                                    }}
                                                  />
                                                )}
                                              />
                                            </SkeletonWrapper>
                                          </FormControl> */}
                                          <FormControl fullWidth>
                                            <FormLabel
                                              className={`fileds-label-text  ${
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll &&
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.doseId
                                                  ? "validation-message"
                                                  : ""
                                              }`}
                                            >
                                              Dose *
                                            </FormLabel>
                                            <SkeletonWrapper
                                              isLoading={isLoading}
                                              className="skeleton-input"
                                            >
                                              <CustomTextField
                                                placeholder={
                                                  "Birth Dose / Dose 1 / Booster Dose"
                                                }
                                                autoCapitalize="none"
                                                type="text"
                                                id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseName`}
                                                size="small"
                                                autoFocus
                                                disabled
                                                value={vaccineSchedule.doseName}
                                                onChange={(e) => {
                                                  methods.setValue(
                                                    `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseName`,
                                                    e.target.value,
                                                    {
                                                      shouldValidate: true,
                                                    },
                                                  );
                                                }}
                                                className={`fileds-label-text  ${
                                                  methods.formState.errors
                                                    ?.vaccinationSchedulecoll &&
                                                  methods.formState.errors
                                                    ?.vaccinationSchedulecoll[
                                                    vaccineSchedule.displayOrder
                                                  ]?.doseId
                                                    ? "validation-message"
                                                    : ""
                                                }`}
                                              />
                                            </SkeletonWrapper>
                                          </FormControl>
                                        </Grid>
                                        {reason === "GIVEN" && (
                                          <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                              <FormLabel
                                                className={`fileds-label-text  ${
                                                  methods.formState.errors
                                                    ?.vaccinationSchedulecoll &&
                                                  methods.formState.errors
                                                    ?.vaccinationSchedulecoll[
                                                    vaccineSchedule.displayOrder
                                                  ]?.batchNumber
                                                    ? "validation-message"
                                                    : ""
                                                }`}
                                              >
                                                Batch Number
                                              </FormLabel>
                                              <SkeletonWrapper
                                                isLoading={isLoading}
                                                className="skeleton-input"
                                              >
                                                <CustomTextField
                                                  placeholder=""
                                                  autoCapitalize="none"
                                                  type="text"
                                                  fullWidth
                                                  id="patientName"
                                                  size="small"
                                                  {...methods.register(
                                                    `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.batchNumber`,
                                                  )}
                                                  error={
                                                    !!(
                                                      methods.formState.errors
                                                        ?.vaccinationSchedulecoll &&
                                                      methods.formState.errors
                                                        ?.vaccinationSchedulecoll[
                                                        vaccineSchedule
                                                          .displayOrder
                                                      ]?.batchNumber
                                                    )
                                                  }
                                                />
                                              </SkeletonWrapper>
                                            </FormControl>
                                            <Typography className="validation-message">
                                              {methods.formState.errors
                                                ?.vaccinationSchedulecoll &&
                                                methods.formState.errors
                                                  ?.vaccinationSchedulecoll[
                                                  vaccineSchedule.displayOrder
                                                ]?.batchNumber?.message}
                                            </Typography>
                                          </Grid>
                                        )}
                                        {/* {reason === "GIVEN" && (
                                          <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth>
                                              <FormLabel className="fileds-label-text">
                                                Upload
                                              </FormLabel>
                                              <MultiUpload
                                                onDropandSelect={
                                                  saveLogoFileSelected
                                                }
                                                editFile={documentsFiles}
                                                MAX_COUNT={5}
                                                onFileDownload={
                                                  dowloadDocumentFile
                                                }
                                                onFileRemove={(file) => {
                                                  removeFile(file);
                                                }}
                                              />
                                            </FormControl>
                                          </Grid>
                                        )} */}
                                      </Grid>
                                    </Box>
                                  </Grid>
                                  {/* {arrLength === index + 1 && (
                                  <Grid item container sx={{ mt: 1 }}>
                                    <Button
                                      variant="text"
                                      style={{ fontSize: "6px" }}
                                      onClick={() => {
                                        addRowAddVaccine();
                                      }}
                                    >
                                      <AddIcon className="add-icon" />
                                      <span className="add-icon"> ADD ANOTHER VACCINE</span>
                                    </Button>
                                  </Grid>
                                )} */}
                                </Box>
                              </Grid>
                            );
                          })}
                      </Grid>
                    </Box>
                  )}
                  <Box>
                    {!selected?.name ? (
                      completedSummary?.length > 0 ? (
                        <Box
                          sx={{
                            //padding: "16px 20px",
                            fontSize: "13px",
                            fontWeight: 500,
                          }}
                        >
                          <Box>
                            {completedSummary.map((item, index) => {
                              if (!item) return null; // Handle cases where item is null or undefined

                              return (
                                <div
                                  key={index}
                                  style={{
                                    padding: "15px",
                                    borderTop:
                                      index === 0
                                        ? "none"
                                        : "1px solid #e1eaf1",
                                  }}
                                >
                                  {item.brandName ||
                                  item.name ||
                                  item.doseName ? (
                                    <strong style={{ fontSize: "14px" }}>
                                      {item.brandName
                                        ? `${item.brandName} `
                                        : ""}
                                      {item.name ? `(${item.name}) ` : ""}
                                      {item.doseName || ""}
                                    </strong>
                                  ) : null}

                                  {item.batchNumber && (
                                    <Typography>
                                      {"Batch No: "}
                                      {item.batchNumber}
                                    </Typography>
                                  )}

                                  {(item.caseNumber ||
                                    item.givenOn ||
                                    item.schedualOn) && (
                                    <Typography
                                      className="grey-400"
                                      sx={{ fontSize: "12px" }}
                                    >
                                      {item.caseNumber
                                        ? `${item.caseNumber} | `
                                        : ""}
                                      {item.givenOn
                                        ? `Vaccination Date: ${item.givenOn} | `
                                        : ""}
                                      {item.schedualOn
                                        ? `Schedule Date: ${item.schedualOn}`
                                        : ""}
                                    </Typography>
                                  )}
                                </div>
                              );
                            })}
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: "center",
                            alignItems: "center",
                            height: "150px",
                          }}
                        >
                          <CloudQueueOutlinedIcon
                            color="info"
                            sx={{ height: "30px", width: "30px" }}
                          />
                          <div>No summary found</div>
                        </Box>
                      )
                    ) : null}
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
          <Dialog fullScreen open={open} onClose={handleClose}>
            <Box
              sx={{
                border: "1px solid #0000001f",
                borderRadius: "10px",
                overflow: "hidden",
                backgroundColor: "var(--opd-panel-bg)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "var(--opd-header-bg)",
                }}
                className="inner-header-container"
              >
                <Typography
                  className={selected?.name ? "symptom-text" : ""}
                  style={{ fontWeight: 600 }}
                >
                  {selected?.name
                    ? selected?.name +
                      (selected?.doseName ? " - " + selected?.doseName : "")
                    : "Vaccination Summary"}
                </Typography>
                <Typography>
                  <LoadingButton
                    sx={{ marginRight: "15px" }}
                    color="primary"
                    loadingPosition="start"
                    startIcon={<></>}
                    variant="contained"
                    type="submit"
                    className="primary-button"
                    name="save"
                    // onClick={(e) => {
                    //   // console.log(methods.formState.errors);
                    //   handleClose();
                    // }}
                    onClick={() => {
                      methods.handleSubmit(onSubmit)();
                      handleClose();
                    }}
                    disabled={isLoading}
                  >
                    Save
                  </LoadingButton>
                  <IconButton
                    onClick={() => setOpen(false)} // Change "" to null for better logic
                    sx={{ padding: 0, margin: 0 }}
                    aria-label="delete"
                  >
                    <CloseRoundedIcon sx={{ color: " #d32f2f" }} />
                  </IconButton>
                </Typography>
              </Box>
              <Divider />
              {selected?.name && (
                <Box
                  sx={{
                    padding: "10px",
                  }}
                >
                  <Grid container spacing={2}>
                    {vaccinationSchedulecoll
                      ?.filter((x) => x.isDeleted === false && x.mode !== "D")
                      ?.map((vaccineSchedule, index, arr) => {
                        let arrLength = arr?.length;
                        return (
                          <Grid
                            key={vaccineSchedule?.displayOrder?.toString()}
                            item
                            xs={12}
                          >
                            <Box className="group-container">
                              <Grid container spacing={2}>
                                {reason === "GIVEN" && (
                                  <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                      <FormLabel
                                        className={`fileds-label-text  ${
                                          methods.formState.errors
                                            ?.vaccinationSchedulecoll &&
                                          methods.formState.errors
                                            ?.vaccinationSchedulecoll[
                                            vaccineSchedule.displayOrder
                                          ]?.givenOn
                                            ? "validation-message"
                                            : ""
                                        }`}
                                      >
                                        Vaccination Date *
                                      </FormLabel>
                                      <SkeletonWrapper
                                        isLoading={isLoading}
                                        className="skeleton-input"
                                      >
                                        <DatePickerComponent
                                          format="DD-MM-YYYY"
                                          disabled={false}
                                          mode="date"
                                          maxDate={dayjs()}
                                          slotProps={{
                                            textField: { size: "small" },
                                          }}
                                          value={
                                            vaccinationSchedulecoll[
                                              vaccineSchedule.displayOrder
                                            ]?.givenOn
                                              ? dayjs(
                                                  vaccinationSchedulecoll[
                                                    vaccineSchedule.displayOrder
                                                  ]?.givenOn,
                                                )
                                              : null
                                          }
                                          onChange={(e: any) => {
                                            if (e !== null && isValid(e.$d)) {
                                              let savedDateFormate: any =
                                                format(e.$d, "yyyy-MM-dd");
                                              methods.setValue(
                                                `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.givenOn`,
                                                savedDateFormate,
                                              );
                                            }
                                          }}
                                        />
                                      </SkeletonWrapper>
                                    </FormControl>
                                  </Grid>
                                )}
                                {["NEXT_SCHEDULE", "CUSTOM"].includes(
                                  reason,
                                ) && (
                                  <Grid item xs={12} sm={6} md={6}>
                                    <FormControl fullWidth>
                                      <FormLabel
                                        className={`fileds-label-text  ${
                                          methods.formState.errors
                                            ?.vaccinationSchedulecoll &&
                                          methods.formState.errors
                                            ?.vaccinationSchedulecoll[
                                            vaccineSchedule.displayOrder
                                          ]?.schedualOn
                                            ? "validation-message"
                                            : ""
                                        }`}
                                      >
                                        Schedule Date *
                                      </FormLabel>
                                      <SkeletonWrapper
                                        isLoading={isLoading}
                                        className="skeleton-input"
                                      >
                                        <DatePickerComponent
                                          format="DD-MM-YYYY"
                                          disabled={false}
                                          mode="date"
                                          // minDate={dayjs()}
                                          // disablePast
                                          slotProps={{
                                            textField: { size: "small" },
                                          }}
                                          value={
                                            vaccinationSchedulecoll[
                                              vaccineSchedule.displayOrder
                                            ]?.schedualOn
                                              ? dayjs(
                                                  vaccinationSchedulecoll[
                                                    vaccineSchedule.displayOrder
                                                  ]?.schedualOn,
                                                )
                                              : null
                                          }
                                          onChange={(e: any) => {
                                            if (e !== null && isValid(e.$d)) {
                                              let savedDateFormate: any =
                                                format(e.$d, "yyyy-MM-dd");
                                              methods.setValue(
                                                `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.schedualOn`,
                                                savedDateFormate,
                                              );
                                            }
                                          }}
                                        />
                                      </SkeletonWrapper>
                                    </FormControl>
                                  </Grid>
                                )}
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={6}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "start",
                                  }}
                                >
                                  {arrLength > 1 && (
                                    <Button
                                      variant="text"
                                      onClick={() => {
                                        removeVaccineSchedule(vaccineSchedule);
                                      }}
                                    >
                                      <RemoveIcon className="remove-note" />
                                      <span className="remove-note">
                                        Remove Vaccine
                                      </span>
                                    </Button>
                                  )}
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Box
                                  sx={{
                                    border: "1px solid lightgray",
                                    borderRadius: 2,
                                    marginTop: "10px",
                                    padding: "10px",
                                    width: "100%",
                                  }}
                                >
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                      <FormControl fullWidth>
                                        <FormLabel
                                          className={`fileds-label-text  ${
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll &&
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll[
                                              vaccineSchedule.displayOrder
                                            ]?.vaccineId
                                              ? "validation-message"
                                              : ""
                                          }`}
                                        >
                                          Generic Name *
                                        </FormLabel>
                                        <SkeletonWrapper
                                          isLoading={isLoading}
                                          className="skeleton-input"
                                        >
                                          <Controller
                                            control={methods.control}
                                            name={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`}
                                            render={({ field }) => (
                                              <CustomAsyncSelect
                                                {...field}
                                                id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`}
                                                FieldName={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`}
                                                defaultOptions={vaccineColl}
                                                isDisabled={true}
                                                loadOptions={loadVaccineList}
                                                openMenuOnFocus
                                                isClearable
                                                isSearchable
                                                menuPortalTarget={document.querySelector(
                                                  "body",
                                                )}
                                                isNotCreatable
                                                handleChange={async (e) => {
                                                  if (
                                                    methods
                                                      ?.getValues()
                                                      ?.vaccinationSchedulecoll[
                                                        vaccineSchedule
                                                          .displayOrder
                                                      ]?.vaccineId?.value?.toString() !==
                                                    e?.value?.toString()
                                                  ) {
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineId`,
                                                      e?.value ? e : null,
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.vaccineName`,
                                                      e?.value ? e?.label : "",
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`,
                                                      null,
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandName`,
                                                      "",
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseId`,
                                                      null,
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );

                                                    if (e?.value) {
                                                      setIsLoading(true);
                                                      await fetchVaccineBrand(
                                                        e.value,
                                                        "",
                                                        true,
                                                      );
                                                      await fetchVaccineDose(
                                                        e.value,
                                                        "",
                                                        true,
                                                      );
                                                      setIsLoading(false);
                                                    } else {
                                                      setVaccineBrandColl([]);
                                                      setVaccineDoseColl([]);
                                                    }
                                                  }
                                                }}
                                              />
                                            )}
                                          />
                                        </SkeletonWrapper>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormControl fullWidth>
                                        <FormLabel
                                          className={`fileds-label-text  ${
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll &&
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll[
                                              vaccineSchedule.displayOrder
                                            ]?.brandId
                                              ? "validation-message"
                                              : ""
                                          }`}
                                        >
                                          Brand
                                        </FormLabel>
                                        <SkeletonWrapper
                                          isLoading={isLoading}
                                          className="skeleton-input"
                                        >
                                          <Controller
                                            control={methods.control}
                                            name={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`}
                                            render={({ field }) => (
                                              <CustomAsyncSelect
                                                {...field}
                                                isCreatable
                                                id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`}
                                                FieldName={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`}
                                                defaultOptions={
                                                  vaccineBrandColl
                                                }
                                                loadOptions={(
                                                  input,
                                                  callBack,
                                                ) => {
                                                  loadVaccineBrandList(
                                                    methods.getValues()
                                                      ?.vaccinationSchedulecoll[
                                                      vaccineSchedule
                                                        ?.displayOrder
                                                    ]?.vaccineId?.value ?? "",
                                                    input?.trim(),
                                                    callBack,
                                                  );
                                                }}
                                                isDisabled={
                                                  parseInt(
                                                    methods?.getValues()
                                                      ?.vaccinationSchedulecoll[
                                                      vaccineSchedule
                                                        .displayOrder
                                                    ]?.vaccineId?.value ?? "0",
                                                  ) <= 0
                                                }
                                                openMenuOnFocus
                                                isClearable
                                                isSearchable
                                                menuPortalTarget={document.querySelector(
                                                  "body",
                                                )}
                                                handleChange={(e: any) => {
                                                  if (e?.__isNew__) {
                                                    const vaccineId =
                                                      methods.getValues()
                                                        ?.vaccinationSchedulecoll[
                                                        vaccineSchedule
                                                          ?.displayOrder
                                                      ]?.vaccineId?.value;
                                                    if (vaccineId) {
                                                      const encryptedVaccineId: any =
                                                        edService.encrypt(
                                                          vaccineId,
                                                        );
                                                      navigate(
                                                        `/master/vaccine/vaccine-save?q=${encodeURIComponent(encryptedVaccineId)}`,
                                                      );
                                                    }
                                                  } else {
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandId`,
                                                      e?.value ? e : null,
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );
                                                    methods.setValue(
                                                      `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.brandName`,
                                                      e?.value ? e?.label : "",
                                                      {
                                                        shouldValidate: true,
                                                      },
                                                    );
                                                  }
                                                }}
                                              />
                                            )}
                                          />
                                        </SkeletonWrapper>
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                      <FormControl fullWidth>
                                        <FormLabel
                                          className={`fileds-label-text  ${
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll &&
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll[
                                              vaccineSchedule.displayOrder
                                            ]?.doseId
                                              ? "validation-message"
                                              : ""
                                          }`}
                                        >
                                          Dose *
                                        </FormLabel>
                                        <SkeletonWrapper
                                          isLoading={isLoading}
                                          className="skeleton-input"
                                        >
                                          <CustomTextField
                                            placeholder={
                                              "Birth Dose / Dose 1 / Booster Dose"
                                            }
                                            autoCapitalize="none"
                                            type="text"
                                            id={`vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseName`}
                                            size="small"
                                            autoFocus
                                            disabled
                                            value={vaccineSchedule.doseName}
                                            onChange={(e) => {
                                              methods.setValue(
                                                `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.doseName`,
                                                e.target.value,
                                                {
                                                  shouldValidate: true,
                                                },
                                              );
                                            }}
                                            className={`fileds-label-text  ${
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll &&
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll[
                                                vaccineSchedule.displayOrder
                                              ]?.doseId
                                                ? "validation-message"
                                                : ""
                                            }`}
                                          />
                                        </SkeletonWrapper>
                                      </FormControl>
                                    </Grid>
                                    {reason === "GIVEN" && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                          <FormLabel
                                            className={`fileds-label-text  ${
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll &&
                                              methods.formState.errors
                                                ?.vaccinationSchedulecoll[
                                                vaccineSchedule.displayOrder
                                              ]?.batchNumber
                                                ? "validation-message"
                                                : ""
                                            }`}
                                          >
                                            Batch Number
                                          </FormLabel>
                                          <SkeletonWrapper
                                            isLoading={isLoading}
                                            className="skeleton-input"
                                          >
                                            <CustomTextField
                                              placeholder=""
                                              autoCapitalize="none"
                                              type="text"
                                              fullWidth
                                              id="patientName"
                                              size="small"
                                              {...methods.register(
                                                `vaccinationSchedulecoll.${vaccineSchedule.displayOrder}.batchNumber`,
                                              )}
                                              error={
                                                !!(
                                                  methods.formState.errors
                                                    ?.vaccinationSchedulecoll &&
                                                  methods.formState.errors
                                                    ?.vaccinationSchedulecoll[
                                                    vaccineSchedule.displayOrder
                                                  ]?.batchNumber
                                                )
                                              }
                                            />
                                          </SkeletonWrapper>
                                        </FormControl>
                                        <Typography className="validation-message">
                                          {methods.formState.errors
                                            ?.vaccinationSchedulecoll &&
                                            methods.formState.errors
                                              ?.vaccinationSchedulecoll[
                                              vaccineSchedule.displayOrder
                                            ]?.batchNumber?.message}
                                        </Typography>
                                      </Grid>
                                    )}
                                    {/* {reason === "GIVEN" && (
                                      <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                          <FormLabel className="fileds-label-text">
                                            Upload
                                          </FormLabel>
                                          <MultiUpload
                                            onDropandSelect={
                                              saveLogoFileSelected
                                            }
                                            editFile={documentsFiles}
                                            MAX_COUNT={5}
                                            onFileDownload={dowloadDocumentFile}
                                            onFileRemove={(file) => {
                                              removeFile(file);
                                            }}
                                          />
                                        </FormControl>
                                      </Grid>
                                    )} */}
                                  </Grid>
                                </Box>
                              </Grid>
                              {/* {arrLength === index + 1 && (
                                  <Grid item container sx={{ mt: 1 }}>
                                    <Button
                                      variant="text"
                                      style={{ fontSize: "6px" }}
                                      onClick={() => {
                                        addRowAddVaccine();
                                      }}
                                    >
                                      <AddIcon className="add-icon" />
                                      <span className="add-icon"> ADD ANOTHER VACCINE</span>
                                    </Button>
                                  </Grid>
                                )} */}
                            </Box>
                          </Grid>
                        );
                      })}
                  </Grid>
                </Box>
              )}
              <Box></Box>
            </Box>
          </Dialog>
        </form>
      </FormProvider>
      <Dialog
        className="dialog"
        open={openDialog}
        onClose={handleClose}
        fullScreen
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            width: "1200px",
            maxWidth: "none",
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Typography
              // className={selected ? "symptom-text" : ""}
              style={{ fontWeight: 600, marginLeft: 1 }}
              sx={{
                paddingLeft: {
                  xs: 1,
                  sm: 0,
                },
              }}
              variant="h6"
            >
              History of similar illness
            </Typography>
          </Toolbar>
        </AppBar>
        <Divider />
        <DialogContent className="set-height-small set-height-mobile set-height-medium set-height-large">
          <HistoryOfSimilarIllness />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            color="primary"
            tabIndex={3}
            loadingPosition="start"
            startIcon={<></>}
            variant="contained"
            type="submit"
            className="primary-button"
            name="submit"
            onClick={() => {
              handleClose();
            }}
          >
            Save
          </LoadingButton>
          <LoadingButton
            tabIndex={3}
            loadingPosition="start"
            startIcon={<></>}
            variant="outlined"
            className="secondary-button"
            color="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
